/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation


// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Konstantin",
  title: "Константин Кравченко",
  subTitle: [
    "Гуру постпроцессоров",
    "Разработка модуля PowerMill Robot",
    "Программирование станков",
    "Программирование промышленных роботов",
    "Разработка плагинов и макросов для CAM-систем",
    "Приятные разговоры по душам"],
  resumeLink:
    "",//"https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  telegram: "https://t.me/scarlatin",
  //github: "https://github.com/saadpasta",
  linkedin: "https://linkedin.com/in/konstantinkravchenko/",
  hotmail: "konstantin.kravchenko@hotmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@konstantin.kravchenko",
  youtube: "https://www.youtube.com/channel/UCJuCMadlPn9BriJrvun0a8g",
  elibrary: "https://elibrary.ru/author_items.asp?authorid=701718",
  instagram: "https://www.instagram.com/konstantin.phd",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Чем я могу помочь",
  subTitle: "",
  skills: [
    "Разработка постпроцессоров для любого типа оборудования: фрезерные, токарные, токарно-фрезерные станки, промышленные роботы, прутковые автоматы",
    "Разработка кинематических моделей для станков, промышленных роботов и роботизированных ячеек",
    "Решения для гибридного оборудования и станков с изменяемой кинематикой",
    "Разработка плагинов и макросов для CAM-систем",
    "Обучение работе с CAM-системой",
    "Консалтинг и внедрение"
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // {
    //   skillName: "csharp",
    //   fontAwesomeClassname: "fab fa-csharp"
    // },
    // {
    //   skillName: "JScript",
    //   fontAwesomeClassname: "fab fa-js"
    // },
    // {
    //   skillName: "reactjs",
    //   fontAwesomeClassname: "fab fa-react"
    // },
    // {
    //   skillName: "python",
    //   fontAwesomeClassname: "fab fa-python"
    // },
    // {
    //   skillName: "vbscript",
    //   fontAwesomeClassname: "fab fa-vb"
    // }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Институт физики прочности и материаловедения СО РАН",
      logo: require("./assets/images/ИФПМ СО РАН.jpg"),
      subHeader: "Кандидат технических наук",
      duration: "2016",
      descBullets: [
        "Разработка аналитической и имитационных моделей с элементом запаздывания для исследования устойчивости концевого фрезерования",
        "Предложена унифицированная форма дифферециального уравнения с запаздыванием, которое было положено в основу аналитической модели",
        "Результаты исследования подтверждены экспериментально и внедрены на АО \"Воткинский завод\" и ОАО \"СКБ \"Турбина\"",
        "Модели разработаны с использованием Python 2.7"
      ],
      publications: [
        "https://elibrary.ru/author_items.asp?authorid=701718"
      ]
    },
    {
      schoolName: "Уральский федеральный университет им. первого Президента России Б.Н. Ельцина",
      logo: require("./assets/images/UrFULogo_U.jpg"),
      subHeader: "Аспирантура",
      duration: "2011 - 2015",
      desc: "Аспирант"
    },
    {
      schoolName: "Уральский федеральный университет им. первого Президента России Б.Н. Ельцина",
      logo: require("./assets/images/UrFULogo_U.jpg"),
      subHeader: "Кафедра Технологии машиностроения",
      duration: "2006 - 2011",
      desc: "Инженер (Диплом с отличием)"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  display: true,
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Autodesk PowerMill", //Insert stack or technology you have experience in
      progressPercentage: "99%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Autodesk FeatureCAM",
      progressPercentage: "95%"
    },
    {
      Stack: "Autodesk PartMaker",
      progressPercentage: "75%"
    },
    {
      Stack: "SprutCAM",
      progressPercentage: "65%"
    },
    {
      Stack: "C#",
      progressPercentage: "50%"
    } ,
    {
      Stack: "Python",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Проекты",
  subtitle: "За 10 лет выполнено более 250 проектов. Наиболее интересные кейсы представлены тут",
  projects: [
    {
      imageLight: require("./assets/images/Autodesk-light.webp"),
      imageDark: require("./assets/images/Autodesk-dark.webp"),
      projectName: "Autodesk",
      projectDesc: "Обновление модуля для программирования промышленных роботов для системы PowerMill",
      footerLink: [
      ]
    },
    {
      imageLight: require("./assets/images/MightyBuildings-Light.webp"),
      imageDark: require("./assets/images/MightyBuildings-Dark.webp"),
      projectName: "Mighty Buildings",
      projectDesc: "Реализована симуляция одновременной работы двух роботов, выполнящих сканирование и фрезерование",
      footerLink: [
         {
           name: "Смотреть видео",
           url: "https://youtu.be/N3sPX9EoSZY"
         },
         {
          name: "Workflow",
          url: "https://youtu.be/8kDA6vpKvkg"
        }
      ]
    },
    {
      imageLight: require("./assets/images/Zeiser-Light.webp"),
      imageDark: require("./assets/images/Zeiser-Dark.webp"),
      projectName: "Zeiser Gmbh",
      projectDesc: "Постпроцессор и модель станка с изменяемой кинематикой Chiron FZ08 Precision",
      footerLink: [
        {
          name: "Смотреть видео",
          url: "https://youtu.be/hY6nsnTgBzM"
        }
      ]
    },
    {
      imageLight: require("./assets/images/Sulzer.webp"),
      imageDark: require("./assets/images/Sulzer.webp"),
      projectName: "Sulzer",
      projectDesc: "Нанесение покрытий на лопатки с применением промышленного робота ABB ",
      footerLink: [
      ]
    },
    {
      imageLight: require("./assets/images/VAC-light.webp"),
      imageDark: require("./assets/images/VAC-dark.webp"),
      projectName: "ГЭС-2",
      projectDesc: "Программирование робота KUKA KR120 для операций 3D-печати и фрезерования ",
      footerLink: [
        {
          name: "Подробнее о проекте",
          url: "https://medium.com/@konstantin.kravchenko/impressive-ges2-project-robotic-arm-for-artists-37f41bcd3649"
        }
      ]
    },
    {
      imageLight: require("./assets/images/S7.webp"),
      imageDark: require("./assets/images/S7.webp"),
      projectName: "S7 Technics",
      projectDesc: "Постпроцессоры и модели станков DMG CTX 510 и DMG DMU 50",
      footerLink: [
      ]
    },
    {
      imageLight: require("./assets/images/VysokieTechnologii-light.webp"),
      imageDark: require("./assets/images/VysokieTechnologii-dark.webp"),
      projectName: "Высокие технологии",
      projectDesc: "Постпроцессоры и кинематические модели станков",
      footerLink: [
        {
          name: "Spinner U5",
          url: "https://youtu.be/JL7e330MUyg"
        },
        
        {
          name: "Mazak Variaxis 630",
          url: "https://youtu.be/TmF_rf4I69o"
        }
      ]
    },
    {
      imageLight: require("./assets/images/Rosatom-Light.webp"),
      imageDark: require("./assets/images/Rosatom-Light.webp"),
      projectName: "Росатом",
      projectDesc: "Постпроцессор и кинематическая модель для станка UNI.5 600U",
      footerLink: [
        {
          name: "Смотреть видео",
          url: "https://youtu.be/I628KEz-Iqs"
        }
      ]
    },
    {
      imageLight: require("./assets/images/СКБТурбина.webp"),
      imageDark: require("./assets/images/СКБТурбина.webp"),
      projectName: "СКБ Турбина",
      projectDesc: "Разработка и внедрение обработки импеллеров на станках Kitamura Mytrunnion 5 и DMG DMU50 ",
      footerLink: [
        {
          name: "Подробнее о проекте",
          url: "https://sapr.ru/article/25298"
        }
      ]
    },
    {
      imageLight: require("./assets/images/Тяжмаш.webp"),
      imageDark: require("./assets/images/Тяжмаш.webp"),
      projectName: "Тяжмаш",
      projectDesc: "Решение для программирования роботизированного сварочного комплекса на базе KUKA KR8 с пакетом ArcTech",
      footerLink: [
        {
          name: "Подробнее о проекте",
          url: "https://medium.com/@konstantin.kravchenko/robotic-arc-welding-with-kuka-arctech-software-99fb1fcedabd"
        }
      ]
    },
    {
      imageLight: require("./assets/images/Автоваз-Light.webp"),
      imageDark: require("./assets/images/Автоваз-Dark.webp"),
      projectName: "Автоваз",
      projectDesc: "Постпроцессор и кинематическая модель станка DMG DMU80 FD (Siemens 840D) с дополнительной угловой головой",
      footerLink: [
        {
          name: "Смотреть видео",
          url: "https://youtu.be/NYJeH1n0JoM"
        }
      ]
    },
    {
      imageLight: require("./assets/images/DMG-Light.webp"),
      imageDark: require("./assets/images/DMG-Dark.webp"),
      projectName: "ДМГ Мори Рус",
      projectDesc: "Постпроцессор для станка DMG DMU128, который генерирует основную программу и подпрограммы с траекториями",
      footerLink: [
        {
          name: "Видео",
          url: "https://youtu.be/GjdL2KUulL0"
        }
      ]
    },
    {
      imageLight: require("./assets/images/КБП-Light.webp"),
      imageDark: require("./assets/images/КБП-Dark.webp"),
      projectName: "КБП Щегловский вал",
      projectDesc: "Постпроцессоры для станков Mikron",
      footerLink: [
      ]
    },
    {
      imageLight: require("./assets/images/GM-Light.webp"),
      imageDark: require("./assets/images/GM-Light.webp"),
      projectName: "General Motors Uzbekistan",
      projectDesc: "Постпроцессоры для фрезерного центра (Fanuc 31i-MD) и токарно-фрезерного центра (Fanuc 31i-TD)",
      footerLink: [
      ]
    },
    {
      imageLight: require("./assets/images/FilWrap-Light.webp"),
      imageDark: require("./assets/images/FilWrap-Light.webp"),
      projectName: "Калькулятор намотки",
      projectDesc: "Разработан софт для расчета управляющих программ для операций намотки филамента",
      footerLink: [
        {
          name: "Видео намотки",
          url: "https://youtu.be/DoQgkfvTDQY"
        },
        {
          name: "Workflow",
          url: "https://youtu.be/rPk7Mj6wOlE"
        }
      ]
    }
  ],

  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Ачивки"),
  subtitle:
    "",

  achievementsCards: [
    {
      title: "",
      subtitle:
        "",
      image: "",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Блог",
  subtitle:
    "Последние 8 заметок на Medium",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Связаться со мной"),
  subtitle:
    "Я всегда открыт для общения",
  //number: "+7 (922) 206-73-79",
  email_address: "konstantin.kravchenko@hotmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
